import { useState, useCallback } from 'react';

/**
 * Hook to manage phone number input with (99) 99999-9999 mask.
 * Automatically handles 10 and 11 digit Brazilian phone numbers.
 */
export function usePhoneMask(initialValue: string = '') {
  const [value, setValue] = useState(initialValue);

  const formatPhone = useCallback((phone: string) => {
    // Remove all non-digits
    const numbers = phone.replace(/\D/g, '').slice(0, 11);
    
    // Apply mask based on length
    if (numbers.length <= 2) {
      return numbers.length > 0 ? `(${numbers}` : '';
    }
    
    if (numbers.length <= 6) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
    }
    
    // For 10 digits: (99) 9999-9999
    if (numbers.length <= 10) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 6)}-${numbers.slice(6)}`;
    }
    
    // For 11 digits: (99) 99999-9999
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7)}`;
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatPhone(e.target.value);
    setValue(formatted);
  };

  return {
    value,
    handleChange,
    setValue: (val: string) => setValue(formatPhone(val))
  };
}
